module.exports = __webpack_public_path__ + "static/img/Tristan-Powell.9b3c601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tristan-Powell.jpg
// module id = AuNJ
// module chunks = 0